<ng-container *ngIf="profileField$ | async as profileField">
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="labelIcons"></sh-field-label>
    </dt>

    <ng-container *ngIf="value$ | async as value; else emptyData">
        <ng-container
            *ngTemplateOutlet="
                canSearchEDTFOnClick(profileField.FieldDefinition, value) ? searchableData : nonSearchableData;
                context: { value: value, fieldDefinition: profileField.FieldDefinition }
            "
        >
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #searchableData let-value="value" let-fieldDefinition="fieldDefinition">
    <dd [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(fieldDefinition, value)" class="sh-link sh-description-list__details">
        {{ value }}
    </dd>
</ng-template>

<ng-template #nonSearchableData let-value="value">
    <dd class="sh-description-list__details">{{ value }}</dd>
</ng-template>

<ng-template #emptyData>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
